// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 123 ? "icons" : chunkId) + "-" + {"102":"0cbc96","123":"291c21","657":"3b73c9","779":"040275","932":"d2f5b3"}[chunkId] + ".js";
};